<template>
	<md-dialog
		@md-closed="$emit('close')"
		@md-clicked-outside="$emit('close')"
		:md-active="show"
		style="font-family: 'Montserrat', sans-serif; z-index: 2000"
	>
		<div v-if="show && ticket" style="width: 600px; height: 100vh">
			<!-- Header -->
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">
					<strong>{{ ticket.title }}</strong>
					<br />
					<el-popover
						v-if="user && user.organization.id === '1'"
						placement="bottom"
						:title="$t('status')"
						width="200"
						trigger="hover"
					>
						<div>
							<el-tag
								v-for="el in statusOptions"
								@click="
									e => {
										ticket.status = el
										updateTick(ticket)
										/*	$emit('close')*/
									}
								"
								:type="statusLabelType(el)"
							>
								{{ $t(`${el}-status-ticket`) }}
							</el-tag>
						</div>
						<el-tag slot="reference" :type="statusLabelType(ticket.status)">
							{{ $t(`${ticket.status}-status-ticket`) }}
						</el-tag>
					</el-popover>
				</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close')" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<!-- Body -->

			<div class="dialog-body">
				<div class="messages-container">
					<div class="scrollable" id="scrollable">
						<div
							class="msg-container"
							v-for="msg in messages"
							:key="msg.id + msg.read"
							:class="msg.user.id === user.id ? 'me' : 'not-me'"
						>
							<div class="msg" :class="msg.user.id === user.id ? 'me' : 'not-me'">
								<div class="icon">
									<el-tooltip :content="msg.user.username" :open-delay="150" placement="top">
										<div
											class="round"
											:style="{
												'background-color': msg.user.organization_id === '1' ? '#ffa726' : ''
											}"
										>
											{{ msg.user.username.charAt(0).toUpperCase() }}
										</div>
									</el-tooltip>
								</div>
								<div class="content" :class="msg.user.id === user.id ? 'me' : 'not-me'">
									<div
										class="body"
										:style="{
											'background-color': msg.user.organization_id === '1' ? '#ffa726' : ''
										}"
									>
										<div v-if="isText(msg.content)">
											{{ messageContent(msg.content) }}
										</div>
										<div v-else>
											<div v-if="isImage(msg.content)">
												<img
													@click="downloadFile(msg.content)"
													style="max-width: 300px; max-height: 300px"
													:src="messageDownloadString(msg.content)"
													alt=""
												/>
											</div>
											<div v-else>
												<button @click="downloadFile(msg.content)">
													{{ messageDownloadNAme(msg.content) }}
													<br />
													{{ $t("unsupported-file-download") }}
												</button>
											</div>
										</div>
									</div>
									<div class="date">
										<div class="date-text">
											{{ new Date(msg.created_at).toLocaleString("it-IT", { timezone: "UTC" }) }}
										</div>
										<div class="status" :key="updatestatus + msg.id + forcedid">
											<md-icon
												:key="msg.id + msg.read + 1 + forcedid"
												v-if="msg.read === true && msg.user.id === user.id"
												>done_all</md-icon
											>
											<md-icon
												:key="msg.id + msg.read + 2 + forcedid"
												v-else-if="msg.read === false && msg.user.id === user.id"
											>
												done
											</md-icon>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="separator">
						<div class="line"></div>
					</div>

					<div
						class="send-container"
						v-if="ticket.status != 'closed'"
						style="position: absolute; bottom: 0; right: 0; left: 0; background: #fff"
					>
						<div class="text" ref="newtext">
							<textarea
								@keyup.enter="sendMessage"
								type="textarea"
								v-model="newMessage"
								:placeholder="$t('send-message')"
							>
							</textarea>
						</div>

						<label for="sendfile"
							><md-icon
								style="transform: rotate(90deg) !important; font-size: 34px !important"
								class="md-size-2x"
								>attachment</md-icon
							></label
						>
						<input
							type="file"
							id="sendfile"
							style="max-width: 50px; display: none"
							max-size="2048"
							@change="sendFile($event)"
						/>

						<md-button class="add" @click="sendMessage" :disabled="!newMessage">
							<i class="el-icon-loading" v-if="loading" />
							<md-icon>send</md-icon>
						</md-button>
					</div>
					<div class="send-container" v-else>
						<div class="text" ref="newtext">
							{{ $t("ticket-closed") }}
						</div>
					</div>
				</div>
			</div>
			<!-- Footer -->
			<!--			<div class="dialog-footer">-->
			<!--				<div style="margin-left: auto; margin-right: 0">-->
			<!--					<md-button class="cancel" @click="$emit('close')">-->
			<!--						{{ $t("cancel") }}-->
			<!--					</md-button>-->

			<!--				</div>-->
			<!--			</div>-->
		</div>
	</md-dialog>
</template>
<script>
import axios from "axios"
import { mapActions, mapState } from "vuex"
import { uuid } from "@/modules/builder/utils/utils"

export default {
	name: "ticket-messages",
	props: {
		show: {
			type: Boolean,
			required: true
		},
		ticket: {
			type: Object,
			required: false
		},
		forcedid: {
			type: String
		}
	},
	data: () => ({
		statusOptions: ["open", "processing", "closed"],
		newMessage: "",
		loading: false,
		updater: undefined,
		updatestatus: undefined,
		file: undefined
	}),
	computed: {
		...mapState("user", ["user"]),
		messages() {
			var a = this.updater

			return this.ticket.messages
		}
	},
	created() {
		this.scrollToEnd()
		this.updater = this.uuid()
		this.updatestatus = this.uuid()
		this.setMessagesAsRead()
	},
	watch: {
		show(newValue) {
			if (newValue) {
				this.setMessagesAsRead()
				this.scrollToEnd()
			} else this.clearData()

			this.updatestatus = this.uuid()
		},

		ticket: {
			handler(newvalue) {
				this.setMessagesAsRead()
				// this.$refs["newtext"].focus()
				this.updater = this.uuid()
				this.updatestatus = this.uuid()
				this.scrollToEnd()
			},
			deep: true
		}
	},
	methods: {
		...mapActions("ticketing", ["updateTicket"]),
		updateTick(element) {
			this.updateTicket({ ticketId: element.id, payload: element }).finally(() => {})
		},
		b64toBlob(dataURI, contentType = "image/jpeg") {
			var byteString = atob(dataURI.split(",")[1])
			var ab = new ArrayBuffer(byteString.length)
			var ia = new Uint8Array(ab)

			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i)
			}
			return new Blob([ab], { type: contentType })
		},
		downloadFile(val) {
			const blob = this.b64toBlob(this.messageDownloadString(val), JSON.parse(val).type)
			const link = document.createElement("a")
			link.href = URL.createObjectURL(blob)
			link.download = this.messageDownloadNAme(val)
			link.click()
			URL.revokeObjectURL(link.href)
		},
		messageContent(val) {
			return JSON.parse(val).text
		},
		messageMultimedia(val) {
			return JSON.parse(val).base64
		},
		messageDownloadString(val) {
			return "data:" + JSON.parse(val).type + ";base64," + JSON.parse(val).base64
		},
		messageDownloadNAme(val) {
			return JSON.parse(val).name
		},

		isText(val) {
			var tmp = JSON.parse(val)
			if (tmp["text"] !== undefined) {
				return true
			} else {
				return false
			}
		},
		isImage(val) {
			switch (true) {
				case JSON.parse(val).type.includes("image"):
					return true

				default:
					return false
			}
		},

		scrollToEnd: function () {
			this.$nextTick(() => {
				var container = this.$el.querySelector("#scrollable")
				container.scrollTop = container.scrollHeight
			})
		},
		uuid,
		clearData() {
			this.newMessage = ""
			this.loading = false
		},
		setMessagesAsRead() {
			if (this.ticket) {
				if (this.ticket.messages) {
					let unreadMessages = this.ticket.messages.filter(
						message => !message.read && message.user.id !== this.user.id
					)

					let apiCalls = unreadMessages.map(({ id }) =>
						axios.put(
							`${process.env.VUE_APP_API_URL}/api/ticket-message/${id}`,
							{ read: true },
							{ headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } }
						)
					)

					axios
						.all(apiCalls)
						.then(() => {
							unreadMessages.forEach(({ id: unreadMessageId }) => {
								const message = this.ticket.messages.find(msg => {
									return msg.id === unreadMessageId && msg.sender_id !== this.user.id
								})
								message.read = true
							})
						})
						.catch(errors => console.error(errors))
				}
			}
		},
		statusLabelType(status) {
			const types = {
				open: "danger",
				processing: "warning",
				closed: "success"
			}

			return types[status] || "info"
		},
		sendMessage() {
			if (this.ticket.status != "closed") {
				this.loading = true

				const newMessage = {
					id: this.uuid(),
					content: JSON.stringify({ text: this.newMessage }),
					user: this.user,
					created_at: new Date().toString()
				}

				this.ticket.messages.push(newMessage)

				axios
					.post(
						`${process.env.VUE_APP_API_URL}/api/ticket-message`,
						{ ticketId: this.ticket.id, content: JSON.stringify({ text: this.newMessage }) },
						{ headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } }
					)
					.then(({ data: message }) => this.ticket.messages.push(message))
					.catch(() => this.$notification("error", this.$t("error-sending-message"), "", 0))
					.finally(() => {
						this.ticket.messages.splice(
							this.ticket.messages.findIndex(({ id }) => id === newMessage.id),
							1
						)

						this.clearData()
					})
			}
		},
		async readFileAsDataURL(file) {
			let result_base64 = await new Promise(resolve => {
				let fileReader = new FileReader()
				fileReader.onload = e => resolve(fileReader.result)
				fileReader.readAsDataURL(file)
			})

			return result_base64.split(",")[1]
		},
		async sendFile(e) {
			if (this.ticket.status != "closed") {
				var file = e.target.files[0] // get first file

				if (file.size / 1024 / 1024 > 5) {
					alert(this.$t("file-too-large"))
					this.file = undefined
					return
				}

				var tmpBase64 = await this.readFileAsDataURL(file)

				var type = file.type
				var name = file.name

				this.loading = true
				const newMessage = {
					id: this.uuid(),
					content: JSON.stringify({ base64: tmpBase64, name: name, type: type }),
					user: this.user,
					created_at: new Date().toString()
				}
				this.ticket.messages.push(newMessage)
				axios
					.post(
						`${process.env.VUE_APP_API_URL}/api/ticket-message`,
						{
							ticketId: this.ticket.id,
							content: JSON.stringify({ base64: tmpBase64, name: name, type: type })
						},
						{ headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` } }
					)
					.then(({ data: message }) => this.ticket.messages.push(message))
					.catch(() => this.$notification("error", this.$t("error-sending-message"), "", 0))
					.finally(() => {
						this.ticket.messages.splice(
							this.ticket.messages.findIndex(({ id }) => id === newMessage.id),
							1
						)

						this.clearData()
					})

				this.file = undefined
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.messages-container {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	.scrollable {
		height: 80vh;
		padding-bottom: 150px;
		overflow-y: scroll;
		.msg-container {
			width: 100%;
			display: flex;
			&.me {
				justify-content: flex-end;
			}
			&.not-me {
				justify-content: flex-start;
			}

			.msg {
				margin: 10px 0;
				width: 70%;
				min-height: 80px;
				height: auto;
				display: flex;
				&.me {
					flex-direction: row-reverse;
					.icon .round {
						background-color: #3979ff;
					}
				}

				&.not-me {
					flex-direction: row;
					.icon .round {
						background-color: #7e7e7e;
					}
				}
				.icon {
					width: 20%;
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: flex-start;
					.round {
						width: 50px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-weight: 700;
						height: 50px;
						border-radius: 50%;
						color: #fff;
					}
				}

				.content {
					flex: 1;
					height: 100%;
					display: flex;
					flex-direction: column;
					.body {
						padding: 15px;
						flex: 1;
						border-radius: 10px;
						word-break: break-word;
					}
					.date {
						display: flex;
						height: 30%;
						padding-left: 5px;
						color: #ababab;
						font-weight: 500;
						padding-right: 5px;
						width: 100%;
						.status {
							padding-left: 10px;
						}
					}
					&.me {
						.body {
							background-color: #3979ff;
							color: #fff;
							font-weight: 800;
						}
						.date {
							justify-content: flex-end;
						}
					}
					&.not-me {
						.body {
							background-color: #7e7e7e;
							color: #fff;
							font-weight: 800;
						}

						.date {
							justify-content: flex-start;
						}
					}
				}
			}
		}
	}
}

.separator {
	margin: 10px 0;
	padding: 0 50px;
	width: 100%;

	.line {
		height: 1px;
		width: 100%;
		background-color: rgba(204, 202, 203, 0.75);
	}
}

.send-container {
	// height: 50px;
	// height: 20vh;
	height: 10vh;
	display: flex;
	justify-content: center;
	// margin-bottom: 10px;
	.text {
		width: 75%;
		min-height: 55px;
		textarea {
			border: 1pt solid #ccc !important;
			font-family: "Montserrat", sans-serif;
			width: 100%;
			border-radius: 10px;
			padding: 15px 15px;
			height: 100%;
			resize: none;
		}
	}
}
</style>
